/* EP Runde 14 (17.10.2026): ausgelagert aus templates/product.json › main › Block custom_liquid_xYT3fj. defer; braucht #epn-side, #epnTabs, #epnSideData. */
(function () {
  'use strict';

  var side = document.getElementById('epn-side');
  if (!side) return;

  var desc = side.querySelector('.product-description');
  var tabs = document.getElementById('epnTabs');
  if (!desc || !tabs) return;

  /* Fremdes <style> und leere <meta>-Reste entfernen */
  Array.prototype.slice.call(desc.querySelectorAll('style')).forEach(function (s) { s.remove(); });
  Array.prototype.slice.call(desc.querySelectorAll('meta')).forEach(function (m) {
    var p = m.parentNode;
    m.remove();
    if (p && p.tagName === 'P' && !p.textContent.trim() && !p.children.length) p.remove();
  });

  /* ---------- Merkmale ----------
     Es wird nichts entfernt und nichts versteckt. Die Bilder werden
     lediglich aus den Merkmalen herausgezogen und über die Liste
     gesetzt, weil sie sonst den Haken verschieben. Überschriften
     und Absätze bleiben sichtbar. */
  var features = Array.prototype.slice.call(desc.querySelectorAll('.ep-short-feature'));

  if (features.length) {
    var container = desc.querySelector('.ep-short-features');

    /* Bilder aus den Merkmalen herausziehen und als eigener Block
       über die Checkliste setzen. Im Merkmal selbst würden sie den
       Haken verschieben und die Überschrift nach unten drücken. */
    var strip = document.createElement('div');
    strip.className = 'epn-strip';
    var hasStrip = false;

    features.forEach(function (feature) {
      Array.prototype.slice.call(feature.querySelectorAll('img')).forEach(function (img) {
        var figure = document.createElement('figure');
        figure.className = 'epn-strip-item';
        figure.appendChild(img);
        strip.appendChild(figure);
        hasStrip = true;
      });
    });

    if (hasStrip && container) container.parentNode.insertBefore(strip, container);

    /* Leere Hüllen aufräumen, die nach dem Herausziehen der Bilder
       zurückbleiben – sie erzeugen sonst Leerraum über der Überschrift. */
    features.forEach(function (feature) {
      Array.prototype.slice.call(feature.querySelectorAll('div, p, span, figure, picture')).forEach(function (el) {
        if (el.textContent.trim()) return;
        if (el.querySelector('img, ul, ol, table, video, iframe, h1, h2, h3, h4, h5, h6')) return;
        el.remove();
      });
      Array.prototype.slice.call(feature.querySelectorAll('br')).forEach(function (br) { br.remove(); });
    });

    /* Leere Merkmale ohne Überschrift entfernen, damit kein
       einzelner Haken ohne Text stehen bleibt */
    features.forEach(function (feature) {
      if (!feature.textContent.trim()) feature.remove();
    });
  }

  /* ---------- Tabellen mobil scrollbar ---------- */
  Array.prototype.slice.call(side.querySelectorAll('.collapsible-tab__text table')).forEach(function (table) {
    if (table.parentNode.classList.contains('epn-table-scroll')) return;
    var w = document.createElement('div');
    w.className = 'epn-table-scroll';
    table.parentNode.insertBefore(w, table);
    w.appendChild(table);
  });

  /* ---------- Immer nur ein Reiter offen ---------- */
  var all = Array.prototype.slice.call(side.querySelectorAll('.collapsible-tab'));
  all.forEach(function (tab) {
    tab.addEventListener('toggle', function () {
      if (!tab.open) return;
      all.forEach(function (other) { if (other !== tab) other.open = false; });
    });
  });

  /* ==========================================================
     Kaufargumente: Lieferversprechen, Lagerbestand, Preis je Einheit
     ========================================================== */
  var DATA;
  try { DATA = JSON.parse(document.getElementById('epnSideData').textContent); }
  catch (e) { return; }

  var variants = DATA.variants || [];
  var index = Math.max(0, variants.findIndex(function (v) { return v.id === DATA.current; }));

  var shipRow = document.getElementById('epnShip');
  var shipText = document.getElementById('epnShipText');
  var stockRow = document.getElementById('epnStock');
  var stockDot = document.getElementById('epnStockDot');
  var stockText = document.getElementById('epnStockText');
  var unitRow = document.getElementById('epnUnit');


  var DAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var CUTOFF_HOUR = 15;

  function isWorkday(d) { var w = d.getDay(); return w >= 1 && w <= 5; }

  function nextWorkday(d) {
    var next = new Date(d.getTime());
    do { next.setDate(next.getDate() + 1); } while (!isWorkday(next));
    return next;
  }

  /* Versand Mo–Fr bis 15 Uhr, Zustellung am nächsten Werktag. */
  function shipping() {
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, 0, 0, 0);
    var todayPossible = isWorkday(now) && now < cutoff;

    if (todayPossible) {
      var msLeft = cutoff - now;
      var hours = Math.floor(msLeft / 3600000);
      var minutes = Math.floor((msLeft % 3600000) / 60000);
      var left = hours > 0 ? hours + ' Std ' + minutes + ' Min' : minutes + ' Min';
      return {
        html: '<strong>Noch ' + left + ' bestellen</strong>' +
              '<span class="epn-sub">Versand heute, Lieferung voraussichtlich am ' +
              DAYS[nextWorkday(now).getDay()] + '</span>',
        live: true
      };
    }

    var shipDay = isWorkday(now) ? nextWorkday(now) : nextWorkday(now);
    if (isWorkday(now) && now >= cutoff) shipDay = nextWorkday(now);
    var deliverDay = nextWorkday(shipDay);

    return {
      html: '<strong>Bestellung bis 15 Uhr am ' + DAYS[shipDay.getDay()] + '</strong>' +
            '<span class="epn-sub">Lieferung voraussichtlich am ' + DAYS[deliverDay.getDay()] + '</span>',
      live: false
    };
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* "60 Kapseln" -> 60 Stück. Gewichts- und Volumenangaben ignorieren,
     dafür zeigt das Theme bereits den Grundpreis. */
  function unitPrice(v) {
    if (!v.contents || !v.price) return null;
    var match = String(v.contents).match(/(\d+)\s*(kapsel|kapseln|tablette|tabletten|portion|portionen|riegel|beutel|stück|stueck|sticks?)/i);
    if (!match) return null;
    var count = parseInt(match[1], 10);
    if (!count || count < 2) return null;

    var word = match[2].toLowerCase();
    var label = 'Stück';
    if (word.indexOf('kapsel') === 0) label = 'Kapsel';
    else if (word.indexOf('tablette') === 0) label = 'Tablette';
    else if (word.indexOf('portion') === 0) label = 'Portion';
    else if (word.indexOf('riegel') === 0) label = 'Riegel';
    else if (word.indexOf('beutel') === 0) label = 'Beutel';
    else if (word.indexOf('stick') === 0) label = 'Stick';

    return formatPrice(v.price / count) + ' ' + DATA.currency + ' pro ' + label;
  }

  function renderAssurance() {
    var v = variants[index];
    if (!v) return;

    /* Lagerbestand */
    if (!v.available) {
      stockDot.className = 'epn-dot is-out';
      stockText.innerHTML = '<strong>Derzeit nicht auf Lager</strong>' +
        '<span class="epn-sub">Lass dich benachrichtigen, sobald diese Sorte wieder da ist</span>';
      stockRow.hidden = false;
      shipRow.hidden = true;
    } else {
      if (v.tracked && v.qty > 0) {
        /* Bezugsgröße für 100 %: ab dieser Menge ist der Balken voll.
           Je höher der Wert, desto niedriger fällt die Prozentzahl
           bei gleichem Bestand aus. */
        var FULL_STOCK = 500;

        var pct = Math.min(100, Math.max(4, Math.round((v.qty / FULL_STOCK) * 100)));
        var level, headline, sub;

        if (v.qty <= 5) {
          level = 'is-crit';
          headline = 'Nur noch wenige auf Lager';
          sub = 'Fast ausverkauft';
        } else if (v.qty <= 20) {
          level = 'is-mid';
          headline = 'Begrenzt verfügbar';
          sub = 'Gerade stark nachgefragt';
        } else {
          level = 'is-high';
          headline = 'Auf Lager';
          sub = 'Sofort versandfertig';
        }

        stockRow.classList.remove('is-high', 'is-mid', 'is-crit');
        stockRow.classList.add(level);

        stockDot.className = 'epn-dot' +
          (level === 'is-crit' ? ' is-crit' : level === 'is-mid' ? ' is-low' : '');

        stockText.innerHTML =
          '<strong>' + headline + '</strong>' +
          '<span class="epn-sub">' + sub + '</span>' +
          '<span class="epn-barrow">' +
            '<span class="epn-bar"><span style="width:' + pct + '%"></span></span>' +
            '<span class="epn-pct">' + pct + '&nbsp;%</span>' +
          '</span>';
      } else {
        stockRow.classList.remove('is-mid', 'is-crit');
        stockRow.classList.add('is-high');
        stockDot.className = 'epn-dot';
        stockText.innerHTML = '<strong>Auf Lager</strong>' +
          '<span class="epn-sub">Sofort versandfertig</span>';
      }
      stockRow.hidden = false;

      var ship = shipping();
      shipText.innerHTML = ship.html;
      shipRow.hidden = false;
    }

    /* Preis je Einheit */
    var unit = unitPrice(v);
    if (unit) {
      unitRow.innerHTML = 'Entspricht <strong>' + unit + '</strong>';
      unitRow.hidden = false;
    } else {
      unitRow.hidden = true;
    }
  }

  function syncFromTheme(id) {
    var i = variants.findIndex(function (v) { return String(v.id) === String(id); });
    if (i > -1 && i !== index) { index = i; renderAssurance(); }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && t.closest('form[action*="/cart/add"]')) syncFromTheme(t.value);
  });

  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.id) syncFromTheme(v.id);
    });
  });

  renderAssurance();
  window.setInterval(renderAssurance, 30000);
})();
